import { render } from "./PatientScheduleView.vue?vue&type=template&id=c3a7b622"
import script from "./PatientScheduleView.vue?vue&type=script&lang=js"
export * from "./PatientScheduleView.vue?vue&type=script&lang=js"

import "./PatientScheduleView.vue?vue&type=style&index=0&id=c3a7b622&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__